var Domain;
(function (Domain) {
    Domain["WWW"] = "www";
    Domain["LEGAL"] = "legal";
})(Domain || (Domain = {}));
export var CookieDomain;
(function (CookieDomain) {
    CookieDomain["PLAYGROUND"] = "localhost";
    CookieDomain["DEV"] = "dev.polestar.com";
    CookieDomain["STAGING"] = "staging.polestar.com";
    CookieDomain["PROD"] = "www.polestar.com";
    CookieDomain["ALL"] = ".polestar.com";
})(CookieDomain || (CookieDomain = {}));
export var AuthDomain;
(function (AuthDomain) {
    AuthDomain["PLAYGROUND"] = "https://staging.polestar.com";
    AuthDomain["DEV"] = "https://dev.polestar.com";
    AuthDomain["STAGING"] = "https://staging.polestar.com";
    AuthDomain["PROD"] = "https://www.polestar.com";
})(AuthDomain || (AuthDomain = {}));
export default Domain;
